import { render } from "./TeamsStats.vue?vue&type=template&id=07336147&scoped=true"
import script from "./TeamsStats.vue?vue&type=script&lang=js"
export * from "./TeamsStats.vue?vue&type=script&lang=js"

import "./TeamsStats.vue?vue&type=style&index=0&id=07336147&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07336147"]])

export default __exports__